import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetAllClientesTiendaUseCase } from "../../bussines/useCases/GetAllClientesTiendaUseCase";
import { ClientesTiendaDtSourceImplRest } from "../../data/dataSources/ClientesTiendaDtSourceImplRest"
import { ClientesTiendaRepositoryImpl } from "../../data/repositories/ClientesTiendaRepositoryImpl";

export const useClientesTienda = () => {
    const conceptosDtSourceRest = new ClientesTiendaDtSourceImplRest();
    const repository = new ClientesTiendaRepositoryImpl(conceptosDtSourceRest);

    const getAllClientesTienda = async () => {
        const getAllClientesTiendaUseCase = new GetAllClientesTiendaUseCase(repository);
        const result = await executeUseCase({ input: null, useCase: getAllClientesTiendaUseCase });
        return result;
    }

    return {
        getAllClientesTienda
    }
}